import { ResolverTag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { FormMethod } from '@swf/core/enums';

const submitRef = (element: HTMLFormElement) => element?.submit();

const RedirectForm: React.FC<{
  context: Record<string, string | number | readonly string[] | undefined>;
}> = ({ context }) => {
  const mitIDRedirect = useResolver(ResolverTag.MitIDRedirect);
  const callbackRedirect = useResolver(ResolverTag.SwcCallbackRedirectMitId);
  const [formRef, setFormRef] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const [pageElement] = document.getElementsByTagName('body');
    const element = document.createElement('div');
    element.setAttribute('id', 'redirectFormPortalRef');

    pageElement?.appendChild(element);
    setFormRef(element);

    return () => {
      pageElement.removeChild(element);
    };
  }, []);

  const form = (
    <form ref={submitRef} method={FormMethod.Post} action={callbackRedirect}>
      <input type="hidden" name="method" value={FormMethod.Get} />
      <input type="hidden" name="url" value={mitIDRedirect} />
      {Object.keys(context).map((name) => (
        <input
          key={`context.${name}`}
          type="hidden"
          name={`context[${name}]`}
          value={context[name]}
        />
      ))}
    </form>
  );

  return callbackRedirect && formRef && mitIDRedirect ? ReactDOM.createPortal(form, formRef) : null;
};

export default RedirectForm;
